import Animated, {
  interpolate,
  SharedValue,
  useAnimatedStyle,
} from "react-native-reanimated";
import React, { PropsWithChildren, useMemo } from "react";

import { useRadiusSize } from "arkh";
import { useWidgetLayout } from "../WidgetLayoutContext";
import { Platform, Pressable } from "react-native";

export const PageWrapper = ({
  children,
  index,
  y,
  length,
  onPress,
}: PropsWithChildren<{
  index: number;
  y: SharedValue<number>;
  length: number;
  onPress: () => void;
}>) => {
  const { width, height } = useWidgetLayout();

  const inputRange = useMemo(
    () =>
      Array(length + 1)
        .fill(0)
        .map((_, index) => index * height),
    [height, length]
  );
  const outputRange = useMemo(
    () =>
      Array(length + 1)
        .fill(0.6)
        .map((_, i) => (i === index ? 1 : 0.8)),
    [index, length]
  );
  const animatedStyles = useAnimatedStyle(() => {
    if (Platform.OS === "web") {
      return {};
    }
    return {
      transform: [
        {
          scale: interpolate(y.value, inputRange, outputRange),
        },
      ],
    };
  });
  const borderRadius = useRadiusSize("medium");

  return (
    <Pressable
      onPress={() => {
        onPress();
      }}
    >
      <Animated.View
        style={[
          {
            width,
            height,
            borderRadius,
            overflow: "hidden",
          },
          animatedStyles,
        ]}
      >
        {children}
      </Animated.View>
    </Pressable>
  );
};
